module.exports = __webpack_public_path__ + "img/visa.f068b5a8.png";